import { LoadingSection } from '#/components/LoadingSection/LoadingSection';
import type { CmsApiRecommendedJobsBlockData } from '#/modules/cms/api/types/blocks/CmsApiRecommendedJobsBlock';
import { gutterWidth } from '#/theme/theme';
import { dynamic } from '#/utils/dynamic';

import { CmsRecommendedJobsBlock_Box_1 } from './CmsRecommendedJobsBlock.styled';

const DynamicCmsStandardRecommendedJobs = dynamic(
  () =>
    import('#/modules/cms/blocks/RecommendedJobs/Standard/CmsStandardRecommendedJobs').then(
      (m) => ({ default: m.CmsStandardRecommendedJobs }),
    ),
  { strategy: 'client-only', placeholder: <LoadingSection /> },
);

type Props = {
  data: CmsApiRecommendedJobsBlockData;
  fromCheckbox?: boolean;
};

export function CmsRecommendedJobsBlock({ data, fromCheckbox }: Props) {
  const source = fromCheckbox
    ? 'RECOMMENDED_JOBS_CHECKBOX'
    : 'RECOMMENDED_JOBS_BLOCK';

  if (data.layout === 'SLIM') {
    // Additional gutter to position the arrows within the box
    const additionalXGutter = 76;

    return (
      <CmsRecommendedJobsBlock_Box_1
        data-qa-id="recommended-jobs"
        data-qa-layout={data.layout}
        data-qa-source={source}
        data-qa-job-function={data.jobFunction}
        data-qa-area-of-focus={data.areaOfFocus}
        style={{
          '--px-sm': `${gutterWidth + additionalXGutter}px`,
          '--px-md': `${gutterWidth + additionalXGutter}px`,
        }}
      >
        <DynamicCmsStandardRecommendedJobs
          headline={data.headline}
          layout={data.layout}
          jobFunction={data.jobFunction}
          areaOfFocus={data.areaOfFocus}
          recommendedLocale={data.locale}
          source={source}
        />
      </CmsRecommendedJobsBlock_Box_1>
    );
  }

  return (
    <div
      data-qa-id="recommended-jobs"
      data-qa-layout={data.layout}
      data-qa-source={source}
      data-qa-job-function={data.jobFunction}
      data-qa-area-of-focus={data.areaOfFocus}
    >
      <DynamicCmsStandardRecommendedJobs
        headline={data.headline}
        layout={data.layout}
        jobFunction={data.jobFunction}
        areaOfFocus={data.areaOfFocus}
        recommendedLocale={data.locale}
        source={source}
      />
    </div>
  );
}
